import React from "react";

class RequestResponseDataType extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRequest: false,
      showResponse: false,
    };
  }

  render() {
    return (
      <div style={{ textAlign: "center" }}>
        {this.props.data && typeof this.props.data !== "undefined" ? this.props.data : I18n.t("none")}
        <div style={{ fontSize: "10px", fontWeight: "bold" }}>
          {this.props.row.request ? (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.setState({ showRequest: true });
              }}
            >
              Request
            </a>
          ) : null}
          {this.props.row.request && this.props.row.response ? (
            <span style={{ color: "#AFAFAF" }}> / </span>
          ) : null}
          {this.props.row.response ? (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.setState({ showResponse: true });
              }}
            >
              Response
            </a>
          ) : null}
        </div>
        {this.state.showRequest
          ? this.renderModal("Request XML", this.props.row.request, () =>
              this.setState({ showRequest: false })
            )
          : null}
        {this.state.showResponse
          ? this.renderModal("Response XML", this.props.row.response, () =>
              this.setState({ showResponse: false })
            )
          : null}
      </div>
    );
  }

  renderModal(title, body, onClose) {
    return (
      <div
        className="modal"
        tabIndex="-1"
        role="dialog"
        style={{
          display: "block",
          top: "40px",
        }}
      >
        <div
          className="modal-dialog"
          role="document"
          style={{
            height: "calc(100% - 133px)",
            maxWidth: "calc(100% - 30px)",
          }}
        >
          <div
            className="modal-content"
            style={{
              maxHeight: "calc(100% - 10px)",
            }}
          >
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="close"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                }}
                style={{ position: "relative", right: "1rem" }}
                aria-label="Close"
              >
                <span aria-hidden="true" style={{ color: "#FFF" }}>
                  &times;
                </span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                borderLeft: "1px solid #AFAFAF",
                borderRight: "1px solid #AFAFAF",
              }}
            >
              <pre
                style={{
                  fontSize: "12px",
                  lineHeight: "14px",
                  textAlign: "left",
                }}
              >
                {body}
              </pre>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RequestResponseDataType;
